import { formValueSelector } from 'redux-form';
import { getDBFGraphQlSelection, stringToBoolean } from '../single-choice/utils/selection';
import { AIRPORT_TRANSFER } from '../products';
import getIcon from './utils/icon';
import AirportTransfer from './components/AirportTransfer';
import { NoneOption } from './components/utils';
const formSection = AIRPORT_TRANSFER.name;
const getSelected = (name, form) => state => {
  const formData = formValueSelector(form)(state, name);
  return formData ? stringToBoolean(formData === null || formData === void 0 ? void 0 : formData.value) : null;
};
const getPrice = (name, form) => state => {
  const formData = formValueSelector(form)(state, name);
  const totalPrice = formData ? formData.selectionTravelerExternalChoice.reduce((total, choice) => total + choice.price, 0) : null;
  return totalPrice;
};
const getGraphQlSelection = name => _ref => {
  let {
    form,
    state
  } = _ref;
  const formData = formValueSelector(form)(state, name);
  const UiSelection = formData === null || formData === void 0 ? void 0 : formData.value;
  const productId = String(AIRPORT_TRANSFER.id);
  if (!productId || !UiSelection || UiSelection === NoneOption) {
    return null;
  }
  const selections = formData.selectionTravelerExternalChoice;
  return {
    productId,
    selectionTravelerExternalChoice: selections.map(selection => {
      return {
        travelerId: selection.travelerId,
        choiceId: selection.choiceId
      };
    })
  };
};
export const airportTransfer = {
  formSection,
  getIcon,
  getPrice: getPrice.bind(null, formSection),
  getSelected: getSelected.bind(null, formSection),
  getGraphQlSelection: getGraphQlSelection(formSection),
  getDBFGraphQlSelection: getDBFGraphQlSelection(formSection, 'none'),
  ...AIRPORT_TRANSFER
};
export default AirportTransfer;
//# sourceMappingURL=index.js.map